import React, { Component } from 'react';
import classNames from 'classnames';
import Reaptcha from 'reaptcha';
import {dogrulaBos} from "../Kitaplik/fonksiyonlar";
import BildirimKutusu from "../Kitaplik/BildirimKutusu";

class GirisForm extends Component {

    constructor(props) {
        super(props);

        this.state = {

            // fields
            ogrenciTCNo : '',
            captchaResponse: false,
            // errors
            hataOgrenciTCNo : false,
            hataCaptcha: false,

            // server side fields
            istekId : 0,
            mesgul : false,
            basarili: false,
            captcha: false,
        };

        this.ajax = false;
        this.recaptcha = false;

        this.input_onChange = this.input_onChange.bind(this);
        this.giris_onClick = this.giris_onClick.bind(this);
        this.hataCevapTemizle = this.hataCevapTemizle.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
        this.expireCallback = this.expireCallback.bind(this);
    }

    componentDidMount() {
        // constructorda calsımadıgı ıcın buraya koyuldu
        if(env.captcha) {
            //sayfa yenilendi ilk açıldıgında captcha görüntülenirse
            setTimeout(()=> {
                this.setState({captcha : true});
            }, 1000);
        }
    }

    // componentDidUpdate(prevProps, prevState) {
    //     if (prevState.hataCevap === false && this.state.hataCevap) {
    //         scrollToViewport(this.baslik);
    //     }
    // }

    input_onChange(e) {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    // input_onBlur(e) {
    //
    // }
    //
    // input_onKeyPress(e) {
    //     if (e.which === 13 /* Enter */) {
    //         this.parola.focus();
    //     }
    // }

    /**
     * OgrenciTCNo dorulaması yapar
     * @returns {boolean|string} hata yoksa false, hata varsa hata mesajı döner
     */
    dogrulaOgrenciTCNo() {
        return dogrulaBos(this.state.ogrenciTCNo, 'Öğrenci veya T.C. Kimlik No');
    }

    dogrulaCaptcha() {
        if(env.reCAPTCHA.goster && !this.state.captchaResponse) {
            return 'Lütfen Robot olmadıgınızı doğrulayın';
        }

        return false;
    }

    /**
     * Tüm alanları dogrular
     *
     * @returns {*} Hata olması durumunda hataları içeren state ile uyumlu bir obje döner,
     * hata olmaması durumunda false döner.
     */
    hepsiniDogrula() {

        let errors = {
            hataOgrenciTCNo: this.dogrulaOgrenciTCNo(),
            hataCaptcha: this.dogrulaCaptcha(),
        };

        for(let prop in errors) {
            if (errors[prop] !== false) {
                return errors;
            }
        }

        return false;
    }

    /**
     * Login hatasını temizler
     */
    hataCevapTemizle() {
        this.setState({hataCevap:false});
    }

    oturumAc(){

        // devam eden bir istek varsa hiç birşey yapma
        if(this.ajax !== false) {
            return;
        }

        let hatalar = this.hepsiniDogrula();

        if (hatalar)
            this.setState(hatalar);
        else
            this.setState({mesgul : true, hataCevap: false, istekId: this.state.istekId +1 }
                , () => {
                    let data = {
                        ogrenciTCNo : this.state.ogrenciTCNo,
                        istekId: this.state.istekId,
                        captchaResponse: env.reCAPTCHA.goster && this.state.captchaResponse
                            ? this.state.captchaResponse : ""
                    };

                    setTimeout( () => {
                        this.ajax = $.ajax({
                            url: '/',
                            type:'POST',
                            dataType: 'json',
                            data
                        }).done((d)=> {
                            this.ajax = false;
                            if(d) {
                                // console.log(d);
                                if(d.basarili === true) {
                                    window.location = d.location;
                                } else {
                                    this.setState(d, ()=> {
                                        // sıfırla
                                        if(this.recaptcha) {
                                            this.recaptcha.reset();
                                        }

                                        this.ogrenciTCNo.focus(); // parolaya odaklan
                                    });
                                }
                            } else {
                                //todo: beklenmedik bir durum oluştu
                            }
                        });
                    }, 500);

                });

    }

    giris_onClick(e){
        e.preventDefault();
        this.oturumAc();
    }

    verifyCallback(captchaResponse) {
        console.log(captchaResponse);
        this.setState({captchaResponse, hataCaptcha:false});
    }
    expireCallback() {
        this.setState({captchaResponse:false, hataCaptcha:false});
    }

    hataYaz(hata) {
        return hata ? <div className="form-control-feedback m--font-danger">{hata}</div> : null
    }

    render(){
        const s = this.state;

        return (
            <div className="m-login__signin">
                <div ref={e=> this.baslik = e} className="m-login__head">
                    <h3 className="m-login__title">
                        Online İşlemler
                    </h3>
                    {s.hataCevap ?
                        <BildirimKutusu baslik="Hata !"
                                        mesaj={s.hataCevap}
                                        buttonOnClick={this.hataCevapTemizle}
                                        className="danger" /> : null
                    }
                </div>

                <form className="m-login__form m-form" >
                    <div className="form-group m-form__group">
                        <input ref={e => this.ogrenciTCNo = e}
                               name="ogrenciTCNo"
                               className="form-control m-input"
                               type="text"
                               placeholder="Öğrenci No / T.C. Kimik No"
                               onChange={this.input_onChange}
                               value={s.ogrenciTCNo}
                               autoComplete="off" />
                        {this.hataYaz(s.hataOgrenciTCNo)}
                    </div>
                    {env.reCAPTCHA.goster &&
                        <div className="text-xs-center" style={{marginTop: 15, marginBottom: 15}}>
                            {this.hataYaz(s.hataCaptcha)}
                            <Reaptcha ref={e => this.recaptcha = e}
                                      id="g-recaptcha"
                                      onVerify={this.verifyCallback}
                                      onExpire={this.expireCallback}
                                      type="image|audio"
                                      hl="tr"
                                      render="explicit"
                                      sitekey={env.reCAPTCHA.siteKey}/>
                        </div>
                    }

                    <div className="m-login__form-action m--margin-top-0">

                        <button onClick={this.giris_onClick}
                                className={ classNames(
                                    "btn btn-brand m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-login__btn--primaryr",
                                    {"m-loader m-loader--right m-loader--light":s.mesgul})}>
                            Sorgula
                        </button>

                    </div>

                </form>
            </div>

        );
    }
}


export default GirisForm;